import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { Reducer } from 'redux';
import { GetIncomeStatementAvailableYearsState, GetIncomeStatementAvailableYearsTypes } from './types';

const initialState: GetIncomeStatementAvailableYearsState = {
    status: HttpRequestStatus.NOOP,
    years: undefined,
    error: undefined
};

const reducer: Reducer<GetIncomeStatementAvailableYearsState> = (state = initialState, action): GetIncomeStatementAvailableYearsState => {
    switch (action.type) {
        case GetIncomeStatementAvailableYearsTypes.GET_INCOME_STATEMENT_AVAILABLE_YEARS_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, error: undefined };
        }
        case GetIncomeStatementAvailableYearsTypes.GET_INCOME_STATEMENT_AVAILABLE_YEARS_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, years: action.payload, error: undefined };
        }
        case GetIncomeStatementAvailableYearsTypes.GET_INCOME_STATEMENT_AVAILABLE_YEARS_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case GetIncomeStatementAvailableYearsTypes.GET_INCOME_STATEMENT_AVAILABLE_YEARS_RESET_STATE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};

export { reducer as getIncomeStatementAvailableYearsReducer };
